// Libraries
import styled from "styled-components"


export const CorporationGeneralInfoContainer = styled.div`
    
`
